import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.5 4.5a2 2 0 11-4 0 2 2 0 014 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9.5 11a2.5 2.5 0 112.5 2.5H7a2.5 2.5 0 010-5m-.5.5a2.5 2.5 0 014-2m.22.185A2.49 2.49 0 009 6.5M4.5 1.333v-1m2.24 1.928l.707-.707M1.554 7.446l.707-.707M7.666 4.5h1m-8.333 0h1m.221-2.946l.707.708"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.329.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.36 2.892l1.06-1.061m-8.839 8.838l1.061-1.061M11.5 6.75H13m-12.5 0H2m.331-4.419l1.061 1.061"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 13.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 33a7.5 7.5 0 117.5 7.5H21a7.5 7.5 0 010-15M19.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0027 19.5M13.5 4V1m6.718 5.783l2.122-2.122M4.661 22.338l2.122-2.122M23 13.5h3m-25 0h3m.661-8.838l2.122 2.122"
  }))
};
export var WeatherPartlyOvercast = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});